import { atom } from "jotai";

import { preAuthenticatedPath_atom } from "../..";
import { sessionAtom } from "../../../../Session";

export const setPreAuthenticatedPathAtom = atom(
  null,
  (get, set, payload: { path: string; force?: boolean }) => {
    const { path } = payload;
    const preAuthenticatedPath = get(preAuthenticatedPath_atom);
    const currentSession = get(sessionAtom);

    const shouldSetPreAuthenticatedPath =
      (!currentSession &&
        !preAuthenticatedPath &&
        path !== "/patron" &&
        !path.includes("/login")) ||
      !!payload.force;

    if (shouldSetPreAuthenticatedPath) {
      set(preAuthenticatedPath_atom, path);
    }
  }
);
